module.exports = __webpack_public_path__ + "static/trinkets-faf877e9fea33ced5978b94037d61304.svg";